
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.75 4.13C22.69 4.02 22.61 3.92 22.51 3.84C22.41 3.77 22.3 3.71 22.17 3.68C22.05 3.66 21.92 3.66 21.8 3.69L15.43 5.28L14.5 4.82L9.04004 2.09C8.86004 2 8.66004 1.98 8.46004 2.03L1.80004 3.69C1.62004 3.74 1.46004 3.84 1.34004 3.99C1.23004 4.13 1.17004 4.31 1.17004 4.5V19.5C1.17004 19.63 1.20004 19.75 1.25004 19.87C1.31004 19.98 1.39004 20.08 1.49004 20.16C1.59004 20.23 1.70004 20.29 1.83004 20.32C1.95004 20.34 2.08004 20.34 2.20004 20.31L8.57004 18.72L14.5 21.68L14.96 21.91C15.08 21.97 15.2 22 15.33 22C15.36 22 15.4 22 15.43 21.99C15.47 21.99 15.5 21.99 15.54 21.98L22.2 20.31C22.38 20.26 22.54 20.16 22.66 20.01C22.77 19.87 22.83 19.69 22.83 19.5V4.5C22.83 4.37 22.8 4.25 22.75 4.13ZM7.83004 17.18L2.83004 18.43V5.15L7.83004 3.9V17.18ZM14.5 19.82L9.50004 17.32V4.18L14.5 6.68V19.82ZM21.17 18.85L16.17 20.1V6.82L21.17 5.57V18.85Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M22.8999 4.46131V19.5029C22.8999 19.6935 22.8318 19.874 22.707 20.0144C22.5708 20.1648 22.3892 20.2651 22.1849 20.3152C22.1849 20.3152 17.3727 21.6035 15.3638 22.0347C14.9212 22.1349 14.5012 21.8341 14.5012 21.433V6.29109C14.5012 5.80976 14.8758 5.38859 15.4092 5.26826L21.7309 3.64906C21.8671 3.61898 22.0146 3.61898 22.1508 3.63903C22.2984 3.66911 22.4232 3.72928 22.5367 3.79947C22.6502 3.8797 22.741 3.97997 22.8091 4.09028C22.8659 4.21061 22.8999 4.33095 22.8999 4.46131Z","fill":"#5D5CFD"}})])
          )
        }
      }
    